<template>
  <v-layout row wrap>
    <div v-if="item.isSuccess" style="flex: 1 0;">
      <v-card-title class="card-bg-2 font-weight-medium py-1">
        The test run has found:
      </v-card-title>
      <v-card-text class="py-2">
        <div v-for="(dataKey,i) in serviceKeys" :key="i">
          <v-icon class="no-transition mr-1">
            {{ dataKey.icon ? dataKey.icon : getMediaTypeIcon(item.media_type) }}
          </v-icon>
          <span>
            {{ item[dataKey.key] }}
          </span>
          <span :class="{ 'grey--text text--darken-1': !hover }" class="">
            {{ pluralize(dataKey.displayName, item[dataKey.key]) }}
          </span>
        </div>
      </v-card-text>
      <v-card-title class="card-bg-2 py-1">
        If the data does not match, review the file or update the importer configuration.
      </v-card-title>
    </div>
    <div style="flex: 1 0;" v-else>
      Test run failed. Review the file or view the logs for details.
    </div>
    <div>
      <div v-if="item.fileName" class="text-xs-right">
        <v-tooltip bottom :open-delay="300">
          <template v-slot:activator="{ on }">
            <v-chip v-on="on" small label>
              <v-icon class="mr-2">attach_file</v-icon>
              {{ item.fileName }}
            </v-chip>
          </template>
          <span> File name </span>
        </v-tooltip>
      </div>
      <div v-if="item.cocCodes" class="text-xs-right">
        <v-tooltip bottom :open-delay="300">
          <template v-slot:activator="{ on }">
            <v-chip v-on="on" small label>
              <v-icon class="mr-2">link</v-icon>
              {{ item.cocCodes }}
            </v-chip>
          </template>
          <span> COC Code </span>
        </v-tooltip>
      </div>
    </div>
  </v-layout>
</template>

<script>
  import { pluralize } from '@/helpers/strings'
  import { serviceKeys } from '@/helpers/datasets/ingestions'
  import { getMediaTypeIcon } from '@/helpers/mediaTypes'
  export default {
    props: {
      item: Object,
      hover: Boolean,
    },
    data: () => ({
      serviceKeys,
    }),
    methods: {
      pluralize,
      getMediaTypeIcon,
    },
  }
</script>